import {styled} from '@vebox/etui-system';
import {Div, DivProps} from '@vebox/etui-system-elements';
import {Theme} from "@vebox/etui-themes";

export const AccordionSectionFarItemWrapper = styled(Div).attrs(
    ({theme, ...rest}: DivProps): DivProps => ({
        pr: `${(theme as Theme).spacing.sm}px`,
        ...rest,
    }),
)<DivProps>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: fit-content;
    height: fit-content;
    max-height: 100%;
    overflow: hidden;
    flex-shrink: 0;
    max-width: calc(100% - 100px);
`;
